{
  "login": {
    "welcomeTitle": "Добро пожаловать",
    "welcomeSubtitle": "Войдите в ваш аккаунт",
    "backHome": "На главную",
    "heroTitle": "Твой Путь Света продолжается",
    "heroText": "Добро пожаловать обратно. Войди в свой аккаунт, чтобы продолжить практики, пообщаться с Мастерами и двигаться по Пути Света с близким по духу окружением. Мы рады видеть тебя снова.",
    "statusPrefix": "Твой путь продолжается — ",
    "statusName": "Войдите",
    "formTitle": "С возвращением",
    "formText": "Продолжай свой Путь Света в компании единомышленников. Открой для себя новые практики, встречи и знания.",
    "emailLabel": "Email",
    "emailPlaceholder": "you@email.com",
    "passwordLabel": "Пароль",
    "passwordPlaceholder": "••••••••",
    "forgotPassword": "Забыли пароль?",
    "submit": "Войти",
    "passkey": "Войти через passkey",
    "passkeyUnavailable": "Вход через passkey пока недоступен. Используйте email и пароль.",
    "newToAgape": "Нет аккаунта?",
    "createAccount": "Создать аккаунт",
    "errorCodeLabel": "Код ошибки",
    "errorCodeHint": "Назовите его поддержке — по нему найдут, что именно не дошло.",
    "errorCodeCopy": "Скопировать код",
    "errorCodeCopied": "Код скопирован"
  },
  "passkeyErrors": {
    "domainMismatch": "Вход через passkey на этом адресе не работает. Войдите по email и паролю.",
    "notSupported": "Этот браузер не поддерживает passkey. Войдите по email и паролю.",
    "alreadyRegistered": "Такой passkey на этом устройстве уже подключён.",
    "failed": "Не получилось войти через passkey. Попробуйте ещё раз или войдите по email и паролю.",
    "enrolFailed": "Не получилось подключить passkey. Попробуйте ещё раз чуть позже."
  },
  "register": {
    "backHome": "На главную",
    "heroTitle": "Твой Путь Света начинается здесь",
    "heroTitlePlain": "Добро пожаловать в Agapella",
    "heroText": "Создай аккаунт, чтобы исследовать практики, знакомиться с Мастерами Агапэ и созвучным окружением; постепенно обретая то, что поддержит на пути именно Тебя.",
    "statusPrefix": "Твой первый статус — ",
    "statusName": "Искатель",
    "successNamePlain": "в Agapella",
    "formTitle": "Создать аккаунт",
    "formText": "Сейчас достаточно самого главного.\nПозже ты сможешь рассказать о своих интересах подробнее.",
    "emailLabel": "Email",
    "emailPlaceholder": "you@email.com",
    "passwordLabel": "Пароль",
    "passwordPlaceholder": "Минимум 8 символов",
    "passwordHelper": "Минимум 8 символов, заглавная буква и цифра",
    "confirmPasswordLabel": "Подтвердите пароль",
    "generatePassword": "Сгенерировать надёжный пароль",
    "submit": "Начать Путь Света",
    "submitPlain": "Создать аккаунт",
    "retry": "Повторить",
    "formError": "Не удалось создать аккаунт. Попробуйте ещё раз.",
    "alreadyHaveAccount": "Уже есть аккаунт?",
    "signIn": "Войти",
    "welcomeTitle": "Добро пожаловать,",
    "successLead": "Сегодня начинается твой Путь Света.",
    "successLeadPlain": "Аккаунт создан — можно начинать.",
    "successText": "Исследуй платформу в своём ритме, знакомься с новыми знаниями и людьми, а Agapella будет рядом, чтобы помочь тебе сделать первые шаги.",
    "successButton": "Войти в пространство Agapella",
    "successNext": "Далее — знакомство с Agapella на главной",
    "togglePassword": "Показать или скрыть пароль",
    "or": "или",
    "signInWithApple": "Войти через Apple",
    "resendConfirmation": "Отправить письмо повторно",
    "resending": "Отправка...",
    "resendSuccess": "Письмо отправлено. Проверьте почту.",
    "checkMailTitle": "Проверьте почту",
    "checkMailLead": "Мы отправили письмо на {{email}}. Перейдите по ссылке из него, чтобы подтвердить адрес.",
    "checkMailHint": "Письма нет? Загляните в «Промоакции» и «Спам» — иногда оно приземляется туда.",
    "changeEmail": "Указать другой адрес",
    "resendIn": "Отправить повторно можно через {{seconds}} с",
    "openInApp": "Открыть в приложении",
    "nativeTitle": "Создание аккаунта",
    "nativeSubtitle": "Заполните данные для регистрации",
    "nameLabel": "Имя",
    "confirmedTitle": "Почта подтверждена",
    "confirmedLead": "Аккаунт активирован. Войдите, чтобы начать.",
    "checkMailNative": "Мы отправили письмо для подтверждения на {{email}}. Перейдите по ссылке, чтобы активировать аккаунт.",
    "signInWithGoogle": "Войти через Google",
    "googleNoToken": "Google не вернул id_token",
    "googleFailed": "Не удалось войти через Google",
    "appleNoToken": "Apple не вернул identityToken",
    "appleFailed": "Не удалось войти через Apple"
  },
  "forgotPassword": {
    "overline": "Восстановление",
    "title": "Сброс",
    "titleHighlight": "пароля",
    "subtitle": "Введите email для получения инструкций",
    "formTitle": "Сброс пароля",
    "formText": "Укажи email, с которым ты регистрировался, — мы отправим ссылку для восстановления доступа.",
    "emailLabel": "Email",
    "emailPlaceholder": "your@email.com",
    "submit": "Отправить ссылку",
    "remembered": "Вспомнили?",
    "signIn": "Войти",
    "successTitle": "Проверьте почту",
    "successMessage": "Мы отправили ссылку для восстановления на",
    "successHint": "Следуйте инструкциям для сброса пароля.",
    "returnToLogin": "Вернуться ко входу",
    "tryAnother": "Попробовать другой email",
    "nativeTitle": "Восстановление пароля",
    "nativeSubtitle": "Введите email, чтобы получить инструкции по сбросу пароля",
    "nativeSubmit": "Отправить инструкции",
    "nativeSuccessText": "Если аккаунт с адресом {{email}} существует, мы отправили на него инструкции по сбросу пароля.",
    "rememberedPassword": "Вспомнили пароль?"
  },
  "resetPassword": {
    "overline": "Безопасность",
    "title": "Новый",
    "titleHighlight": "пароль",
    "subtitle": "Создайте надёжный пароль для вашего аккаунта",
    "newPasswordLabel": "Новый пароль",
    "newPasswordPlaceholder": "Придумайте новый пароль",
    "confirmPasswordLabel": "Подтвердите пароль",
    "confirmPasswordPlaceholder": "Повторите новый пароль",
    "submit": "Подтвердить",
    "cancelLabel": "Отмена?",
    "returnToLogin": "Вернуться ко входу",
    "expiredTitle": "Ссылка устарела",
    "expiredMessage": "Эта ссылка недействительна или устарела.",
    "requestNewLink": "Запросить новую ссылку",
    "successTitle": "Готово!",
    "successMessage": "Ваш пароль обновлён. Теперь можете войти с новыми данными.",
    "goToLogin": "Перейти ко входу",
    "invalidTitle": "Ссылка недействительна",
    "invalidMessage": "Ссылка для сброса пароля устарела или некорректна. Запросите новую.",
    "changedTitle": "Пароль изменён",
    "changedMessage": "Теперь вы можете войти с новым паролем.",
    "orTypeOwn": "или введите свой"
  },
  "confirmEmail": {
    "verifying": "Подтверждаем ваш e-mail…",
    "signIn": "Войти",
    "failedTitle": "Подтверждение не удалось",
    "returnHome": "На главную",
    "alreadyTitle": "Адрес уже подтверждён",
    "alreadyMessage": "Ничего делать не нужно — просто войдите.",
    "expiredTitle": "Ссылка устарела",
    "expiredMessage": "Ссылка действует сутки. Запросите новое письмо — оно придёт на тот же адрес.",
    "requestNew": "Запросить новое письмо",
    "invalidTitle": "Ссылка не подошла",
    "invalidMessage": "Возможно, её обрезал почтовый клиент или скопировали не целиком. Запросите новое письмо — оно придёт на тот же адрес.",
    "backToSignIn": "У меня уже есть аккаунт"
  },
  "validation": {
    "emailRequired": "Введите email",
    "emailInvalid": "Неверный формат email",
    "passwordRequired": "Введите пароль",
    "passwordMinLength": "Пароль должен быть не менее 6 символов",
    "passwordWeak": "Минимум 8 символов, заглавная буква и цифра. Только латинские символы",
    "confirmPasswordRequired": "Подтвердите пароль",
    "passwordsMismatch": "Пароли не совпадают",
    "loginFailed": "Ошибка входа. Попробуйте ещё.",
    "emailTaken": "Этот email уже зарегистрирован.",
    "registerFailed": "Ошибка регистрации. Попробуйте ещё.",
    "resetFailed": "Не удалось сбросить пароль. Ссылка могла устареть.",
    "resetLinkInvalid": "Эта ссылка недействительна или устарела. Запросите новый сброс пароля.",
    "verifyLinkInvalid": "Ссылка для подтверждения повреждена или неполна.",
    "verifyFailed": "Ошибка подтверждения. Ссылка могла устареть."
  },
  "apiErrors": {
    "invalidEmail": "Неверный формат email",
    "emailAlreadyExists": "Этот email уже зарегистрирован.",
    "weakPassword": "Пароль слишком простой. Минимум 8 символов, заглавная буква и цифра.",
    "registrationFailed": "Ошибка регистрации. Попробуйте ещё.",
    "rateLimitExceeded": "Слишком много попыток. Подождите немного и попробуйте снова.",
    "invalidSocialToken": "Не удалось подтвердить вход. Попробуйте ещё раз.",
    "invalidCredentials": "Неверный email или пароль.",
    "emailNotConfirmed": "Email ещё не подтверждён. Проверьте почту — там ссылка для подтверждения.",
    "accountBlocked": "Доступ к аккаунту закрыт. Напишите нам на info@agapella.io, разберёмся.",
    "consentRequired": "Чтобы продолжить, примите Условия использования и дайте согласие на обработку персональных данных.",
    "ageRequired": "Выберите возраст, чтобы продолжить.",
    "ageNotAllowed": "Регистрация доступна с 14 лет."
  },
  "legal": {
    "consentPrefix": "Я принимаю ",
    "loginPrefix": "Входя в аккаунт, вы принимаете ",
    "terms": "Условия использования",
    "consentMid": " и ",
    "privacy": "Политику конфиденциальности",
    "consentA11y": "Принять условия использования и политику конфиденциальности",
    "pdPrefix": "Отмечая это поле, я принимаю ",
    "pdConsentMid": ", подтверждаю, что ознакомился(-лась) с ними, и даю ",
    "pdConsent": "согласие на обработку персональных данных",
    "pdPolicyMid": ". Подробнее об обработке данных читайте в ",
    "pdPolicy": "Политике",
    "pdSuffix": ".",
    "consentA11yPd": "Принять Условия использования и дать согласие на обработку персональных данных",
    "marketingConsent": "Я даю согласие на получение рекламы от АО «Цифровая ИИ Трансформация»",
    "marketingConsentLink": "согласие на получение рекламы",
    "zeroTolerance": "На платформе нулевая терпимость к оскорбительному контенту и абьюзивным пользователям: жалобу разбираем в течение 24 часов, контент удаляем, автора отключаем.",
    "mustAccept": "Чтобы продолжить, примите Условия использования и Политику конфиденциальности.",
    "mustAcceptPd": "Чтобы продолжить, примите Условия использования и дайте согласие на обработку персональных данных.",
    "close": "Закрыть"
  },
  "age": {
    "question18": "Сколько вам лет?",
    "is18": "Мне есть 18",
    "below18": "Мне меньше 18",
    "question14": "Вам уже исполнилось 14?",
    "is14": "Мне есть 14",
    "below14": "Мне меньше 14",
    "back": "Назад",
    "change": "Изменить",
    "summaryAdult": "Возраст: 18 и старше",
    "summaryTeen": "Возраст: от 14 до 17 лет",
    "under14Title": "Регистрация доступна с 14 лет",
    "under14Body": "Мы бережём детей и пока не можем создать аккаунт, если вам меньше 14. Возвращайтесь, когда подрастёте — мы будем рады вам.",
    "required": "Выберите возраст, чтобы продолжить"
  },
  "consentGate": {
    "title": "Пара шагов перед началом",
    "body": "Отметьте возраст и примите документы — без этого мы не можем хранить ваши данные.",
    "updateTitle": "Мы обновили документы",
    "updateBody": "Изменились Пользовательское соглашение и согласие на обработку персональных данных. Чтобы и дальше пользоваться Agapella, ознакомьтесь с ними и примите — до этого доступ к аккаунту ограничен.",
    "continue": "Продолжить",
    "logout": "Выйти",
    "error": "Не получилось сохранить. Проверьте соединение и попробуйте ещё раз.",
    "under14Removed": "Аккаунт удалён: регистрация доступна с 14 лет."
  }
}
